/* eslint-disable react/prop-types */
import React from 'react'
import PropTypes from 'prop-types'
import { getIn } from 'formik'
import { NumberInput as UNumberInput } from 'bs-unified-ui'
import { useTheme } from '@mui/material/styles'

const NumberInput = ({
  field,
  form,
  inputProps,
  error,
  helperText,
  disabled,
  ...props
}) => {
  const theme = useTheme()
  return (
    <UNumberInput
      error={
        !!error ||
        (!!getIn(form.touched, field.name) && !!getIn(form.errors, field.name))
      }
      helperText={
        helperText ||
        (getIn(form.touched, field.name) && getIn(form.errors, field.name))
      }
      inputProps={{
        ...field,
        ...inputProps,
        value: field.value ?? '',
      }}
      sx={{
        '& input:-internal-autofill-selected, input:-webkit-autofill, input:-webkit-autofill:hover, input:-webkit-autofill:focus, input:-webkit-autofill:active':
          {
            WebkitTextFillColor: `${theme.foreground.black} !important`,
          },
      }}
      disabled={disabled || !!form.values?.__readOnly}
      {...props}
    />
  )
}

NumberInput.defaultProps = {
  inputProps: {},
  error: '',
  helperText: '',
  disabled: false,
}

NumberInput.propTypes = {
  inputProps: PropTypes.shape(),
  form: PropTypes.shape().isRequired,
  field: PropTypes.shape().isRequired,
  error: PropTypes.string,
  helperText: PropTypes.string,
  disabled: PropTypes.bool,
}

export default NumberInput
